export default {
  miniSave: {
    icon: 'mdi-car',
    title: 'Vehicle Induction',
  },
  uploadFunction: ({ requestFunction, data }) => {
    return requestFunction.methodRequest(
      `/register/vehicle/induction/${data.vehicleid}`,
      'POST',
      data.questions
    )
  },
  restoreSave: ({ router, saveObj, saveId }) => {
    router.push({
      name: 'vehicles-vehicleid-induction-edit',
      params: { vehicleid: saveObj.data.vehicleid },
      query: { sid: saveId },
    })
  },
}
